import { conformToMask } from 'react-text-mask';
export const maskValue = (value, masking) => {
  if (!masking?.mask || !value) {
    return value;
  }
  return conformToMask(value, masking?.mask, {
    guide: false
  }).conformedValue;
};